import _objectWithoutProperties from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["headers"],
  _excluded2 = ["headers"],
  _excluded3 = ["body", "headers"],
  _excluded4 = ["body", "headers"],
  _excluded5 = ["body", "headers"];
export class FetchUtil {
  constructor(_ref) {
    let {
      baseUrl
    } = _ref;
    this.baseUrl = baseUrl;
  }
  async get(_ref2) {
    let {
        headers
      } = _ref2,
      args = _objectWithoutProperties(_ref2, _excluded);
    const url = this.createUrl(args);
    const response = await fetch(url, {
      method: 'GET',
      headers
    });
    return response.json();
  }
  async getBlob(_ref3) {
    let {
        headers
      } = _ref3,
      args = _objectWithoutProperties(_ref3, _excluded2);
    const url = this.createUrl(args);
    const response = await fetch(url, {
      method: 'GET',
      headers
    });
    return response.blob();
  }
  async post(_ref4) {
    let {
        body,
        headers
      } = _ref4,
      args = _objectWithoutProperties(_ref4, _excluded3);
    const url = this.createUrl(args);
    const response = await fetch(url, {
      method: 'POST',
      headers,
      body: body ? JSON.stringify(body) : undefined
    });
    return response.json();
  }
  async put(_ref5) {
    let {
        body,
        headers
      } = _ref5,
      args = _objectWithoutProperties(_ref5, _excluded4);
    const url = this.createUrl(args);
    const response = await fetch(url, {
      method: 'PUT',
      headers,
      body: body ? JSON.stringify(body) : undefined
    });
    return response.json();
  }
  async delete(_ref6) {
    let {
        body,
        headers
      } = _ref6,
      args = _objectWithoutProperties(_ref6, _excluded5);
    const url = this.createUrl(args);
    const response = await fetch(url, {
      method: 'DELETE',
      headers,
      body: body ? JSON.stringify(body) : undefined
    });
    return response.json();
  }
  createUrl(_ref7) {
    let {
      path,
      params
    } = _ref7;
    const url = new URL(path, this.baseUrl);
    if (params) {
      Object.entries(params).forEach(_ref8 => {
        let [key, value] = _ref8;
        if (value) {
          url.searchParams.append(key, value);
        }
      });
    }
    return url;
  }
}
//# sourceMappingURL=FetchUtil.js.map